import { defineComponent } from "vue";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";

export default defineComponent({
  name: "WorkerData",
  data: () => ({
    processing_employees_by_search: true,
    selected_employee: null,
    processing_search_employee: false,
    search: "",
    employeeId: null,
  }),
  computed: {
    ...mapGetters("modOhAnalyst", ["getEmployeesBySearch"]),
  },
  async beforeMount() {
    await this.getEmployees();
  },
  watch: {
    search: _.debounce(function () {
      this.processing_search_employee = false;
    }, 3000),

    async processing_search_employee(value) {
      if (!value) await this.getEmployees();
    },
  },
  methods: {
    ...mapActions("modOhAnalyst", ["actGetEmployeesBySearch"]),
    async getEmployees() {
      const me = this;
      try {
        me.processing_employees_by_search = true;
        await me.actGetEmployeesBySearch({ search: me.search });

        if (me.employeeId) {
          const employee = me.getEmployeesBySearch?.find(
            (element) => element.id == Number(me.employeeId)
          );

          if (employee) {
            me.$emit("change:employee", employee);
            me.selected_employee = employee;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        me.processing_employees_by_search = false;
      }
    },
    searchEmployee(search) {
      if (!search) return;
      this.processing_search_employee = true;
      this.search = search;
    },
    selectEmployee(employee) {
      if (!employee) return;
      this.$emit("change:employee", employee);
    },
  },
  mounted() {
    const me = this;
    me.employeeId = me.$route.params.type;
  },
});
